<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 36 36"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M18 1c.148 0 .295.002.444.006 7.027.221 12.887 5.984 13.507 13.084.704 8.031-6.387 12.428-10.322 16.434-1.562 1.589-2.464 3.016-2.977 4.062a.727.727 0 0 1-.66.414.727.727 0 0 1-.659-.41c-.521-1.045-1.432-2.474-2.996-4.066C10.586 26.704 4 22.497 4 15.19 4 7.352 10.268 1 18 1zm7.225 21.105c2.185-2.391 3.416-4.682 3.151-7.694-.465-5.316-4.877-9.607-10.042-9.769A12.394 12.394 0 0 0 18 4.638C12.26 4.638 7.588 9.37 7.588 15.19c0 2.667 1.335 4.875 3.143 6.886 1.705-2.141 4.31-3.514 7.236-3.514 2.94 0 5.553 1.384 7.258 3.543zM18.047 16.5c-1.242 0-2.838-1.437-2.838-3.207 0-1.772.468-3.207 2.838-3.207 2.141 0 2.836 1.435 2.836 3.207 0 1.77-1.65 3.207-2.836 3.207z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
